@if (form) {
    <div [formGroup]="form">
        <input type="hidden" [id]="id" [name]="name" [formControlName]="name" [attr.data-identifier]="identifier" />
    </div>
}
